import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_4: FaireProductEntity = {
  token: "atc_refined_moma_4",
  type: "product",
  name: "Modern Dinnerware Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/306fba99bb5b93fe43cbf5a311ec9eab3967ef6fa16edb01991ea615cd8d5aad.webp",
  priceDollars: 55,
  msrpDollars: 88,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
